<template>
  <div class="to-do__datepicker">
    <BaseSubHeading
      size="large"
      weight="400"
      color="monochrome-06"
      class="to-do__datepicker-title"
    >
      Due Date (optional):
    </BaseSubHeading>
    <div class="to-do__datepicker-presets">
      <button
        type="button"
        class="to-do__datepicker-preset is-urgent"
        :class="{ 'is-active': urgent }"
        :aria-pressed="urgent"
        @click="updateUrgent(!urgent)"
      >
        <icon
          data="@icon/flag.svg"
          :fill="true"
          width="var(--icon-16)"
          height="var(--icon-16)"
        />
        Urgent
      </button>
      <button
        type="button"
        class="to-do__datepicker-preset is-today"
        :class="{ 'is-active': today }"
        :aria-pressed="today"
        @click="onCheckboxToday(!today)"
      >
        <icon
          data="@icon/clock.svg"
          :fill="true"
          width="var(--icon-16)"
          height="var(--icon-16)"
        />
        Today
      </button>
      <button
        type="button"
        class="to-do__datepicker-preset is-tomorrow"
        :class="{ 'is-active': tomorrow }"
        :aria-pressed="tomorrow"
        @click="onCheckboxTomorrow(!tomorrow)"
      >
        <icon
          data="@icon/calendar-full.svg"
          width="var(--icon-16)"
          height="var(--icon-16)"
        />
        Tomorrow
      </button>
    </div>
    <div class="to-do__datepicker-input">
      <v-date-picker
        :modelValue="calendarDate"
        mode="date"
        :color="isDark ? 'project' : 'blue'"
        locale="en"
        :firstDayOfWeek="2"
        :minDate="minDate"
        :popover="popoverConfig"
        class="input_to-do"
        @update:modelValue="updateDate"
        @mousedown="$event.stopPropagation()"
      >
        <template #default="{ togglePopover }">
          <button
            id="selectToDoDate"
            type="button"
            class="common-gray-interactive to-do__datepicker-button"
            @click="togglePopover"
          >
            {{ parseDate || "MM/DD/YYYY" }}
            <icon
              data="@icon/calendar.svg"
              width="var(--icon-24)"
              height="var(--icon-24)"
              class="to-do__datepicker-icon"
            />
          </button>
        </template>
        <template #footer>
          <div class="to-do__calendar-heading">
            <span class="to-do__calendar-label">Due Date</span>
            <button
              type="button"
              class="link to-do__calendar-clear"
              @click.stop="updateDate(null)"
            >
              Clear Date
            </button>
          </div>
        </template>
      </v-date-picker>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Emit, Prop } from "vue-property-decorator"
import { Getter } from "s-vuex-class"

import { Getters } from "@/store"
import { formatDate, getTodayCalendarDate, toCalendarDate } from "@/utils/dateUtil"

@Options({
  name: "TodoWidgetDatePicker"
})
export default class TodoWidgetDatePicker extends Vue {
  @Getter(Getters.THEME_IS_DARK) readonly isDark: boolean
  @Prop({ default: false }) today: boolean
  @Prop({ default: false }) tomorrow: boolean
  @Prop({ default: false }) urgent: boolean
  @Prop({ default: null }) date: Date
  popoverConfig = {
    positionFixed: true,
    placement: "bottom-end",
    visibility: "click"
  }

  get minDate() {
    return getTodayCalendarDate()
  }

  get calendarDate() {
    return this.date ? toCalendarDate(this.date) : null
  }

  get parseDate() {
    return this.calendarDate
      ? formatDate(this.calendarDate, "MM/dd/yyyy", { dateOnly: true })
      : null
  }

  @Emit()
  onCheckboxToday(value) {
    return value
  }

  @Emit()
  onCheckboxTomorrow(value) {
    return value
  }

  @Emit()
  updateDate(date: Date | null) {
    return date
  }

  @Emit()
  updateUrgent(value: boolean) {
    return value
  }
}
</script>
